import { render } from "./CompetenceDirectories.vue?vue&type=template&id=656b20a8"
import script from "./CompetenceDirectories.vue?vue&type=script&lang=js"
export * from "./CompetenceDirectories.vue?vue&type=script&lang=js"

import "./CompetenceDirectories.vue?vue&type=style&index=0&id=656b20a8&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__